import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import Overlay from '../Widget/Overlay';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayPublisher from '../Widget/OverlayPublisher';
import WidgetHeader from '../Widget/WidgetHeader';

import { Container } from '../DefaultStyles/Details';
import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    Title
} from '../DefaultStyles/Shared';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { FindRepLink } from '../../components/LocalRep/LocalRep';
import { isLongText } from '../../components/Shared/commonFunctions.js';
import { MultiImageBlock } from '../../components/Image/MultiImageBlock';
import AnswerButton from '../../components/Assessment/AnswerButton';
import CssTransition from '../../components/Transition/CssTransition';
import FindLocalRepPopup from '../../components/LocalRep/FindLocalRepPopup';
import ShareDrawer from '../../components/ShareDrawer';

import {
    goToFindLocalRep,
    hideFindRepPopup,
    loadLocalRep,
    onFindYourRep,
    selectAction
} from '../LocalRep/actions';

import {
    onBackWithinCard,
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible
} from '../Widget/actions';

import { CardTypes } from '../../utils/enums';
import { Placeholders } from '../../utils/fillDynamicText';
import { pictureUrl } from '../../utils/imageLoading';
import {
    buildCachedAddress,
    districtInfo,
    joinEnglish,
    relevantRepresentatives
} from '../../utils/localRepresentative/parser';
import { copyFor } from '../../copy/copy';

import { DefaultRepImageURL } from '../../containers/DefaultStyles/Shared';
import ToasterAlert from '../../components/Donation/ToasterAlert';

class TargetedMultiActionDetails extends React.Component {
    constructor(props) {
        super(props);
        if (!props.localRepFound && props.useLocalRepresentative)
            props.loadLocalRep(
                props.endUserLocation,
                props.cachedAddress,
                props.representativeSearch
            );
    }

    generateSubheading() {
        if (this.props.cardSubHeading) {
            return this.props.cardSubHeading;
        } else if (this.props.localRepFound && this.props.localRepresentatives !== '') {
            return this.props.localRepresentatives;
        } else if (!this.props.isLocalRepLoading) {
            return (
                <FindRepLink onClick={this.props.onFindYourRep}>
                    {copyFor('findReps', 'clickToFind')}
                </FindRepLink>
            );
        }
    }

    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <TransitionGroup>
                    {this.props.addressValidationError && (
                        <CssTransition key="alert" in={this.props.addressValidationError}>
                            <ToasterAlert content={this.props.addressValidationError} />
                        </CssTransition>
                    )}
                </TransitionGroup>
                <Body isBlured={this.props.showFindYouRepPopup}>
                    <WidgetHeader />
                    <Content
                        isContactAction={false}
                        useLocalRepresentative={this.props.useLocalRepresentative}
                        isSingleAction={false}
                    >
                        <Title
                            isLocalRepLoading={this.props.isLocalRepLoading}
                            isLongText={isLongText(this.props.cardHeading, 60)}
                            isExtraLongText={isLongText(this.props.cardHeading, 95)}
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, false)
                            }
                            dangerouslySetInnerHTML={{ __html: this.props.cardHeading }}
                        />
                        <DetailsContainer>
                            <MultiImageBlock
                                isLongTitle={
                                    isLongText(this.props.cardHeading, 40) ||
                                    isLongText(this.props.cardSubHeading, 60)
                                }
                                isLocalRepLoading={this.props.isLocalRepLoading}
                                imgSources={
                                    this.props.useLocalRepresentative
                                        ? this.props.localRepImages.length > 0
                                            ? this.props.localRepImages
                                            : [DefaultRepImageURL]
                                        : this.props.pictureUrl
                                        ? [this.props.pictureUrl]
                                        : [DefaultRepImageURL]
                                }
                            />
                            <Details
                                hasPhoto={
                                    this.props.useLocalRepresentative ||
                                    this.props.pictureUrl
                                }
                            >
                                <Description
                                    isTargetedMultiAction={true}
                                    isLocalRepLoading={this.props.isLocalRepLoading}
                                    isSingleAction={this.props.actions.length === 1}
                                    isLongText={isLongText(this.props.cardSubHeading, 90)}
                                    isExtraLongText={isLongText(
                                        this.props.cardSubHeading,
                                        160
                                    )}
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(
                                            true,
                                            e,
                                            false
                                        )
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: this.generateSubheading()
                                    }}
                                />
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <AutoScalingButtonSet>
                        {this.props.actions.map(a => (
                            <AnswerButton
                                text={a.label.toUpperCase()}
                                useLoadingSpinner={true}
                                key={a.identifier}
                                data-action={a.identifier}
                                onClick={
                                    !this.props.useLocalRepresentative ||
                                    (this.props.localRepFound &&
                                        this.props.localRepresentatives !== '')
                                        ? () => {
                                              this.props.selectAction(a.identifier);
                                              return this.props.onGoToNextActionInsideCard(
                                                  a.identifier,
                                                  a.type,
                                                  false,
                                                  false
                                              );
                                          }
                                        : () => {
                                              this.props.selectAction(a.identifier);
                                              this.props.goToFindLocalRep(
                                                  a.identifier,
                                                  a.type
                                              );
                                          }
                                }
                            />
                        ))}
                    </AutoScalingButtonSet>
                    <Footer>
                        <ShareDrawer
                            goBack={() =>
                                this.props.card.type === CardTypes.actionChoice
                                    ? this.props.onBackWithinCard(
                                          this.props.actionIdentifier,
                                          this.props.card,
                                          true
                                      )
                                    : null
                            }
                            fullwidth={true}
                            hasBackButton={
                                this.props.card.type === CardTypes.actionChoice
                            }
                            backgroundColor={'#fff'}
                        />
                    </Footer>
                </Body>
                <TransitionGroup>
                    {this.props.showFindYouRepPopup && (
                        <CssTransition key="alert" in={this.props.showFindYouRepPopup}>
                            <FindLocalRepPopup
                                address={this.props.address}
                                isLocalRepPopupLoading={this.props.isLocalRepPopupLoading}
                                hideFindRepPopup={this.props.hideFindRepPopup}
                                onSubmit={() =>
                                    this.props.loadLocalRep(
                                        this.props.endUserLocation,
                                        encodeURI(this.props.address),
                                        this.props.representativeSearch,
                                        true
                                    )
                                }
                            />
                        </CssTransition>
                    )}
                </TransitionGroup>
            </Container>
        );
    }
}

TargetedMultiActionDetails.propTypes = {
    address: PropTypes.string.isRequired,
    addressValidationError: PropTypes.any,
    actionIdentifier: PropTypes.string.isRequired,
    actions: PropTypes.array.isRequired,
    cachedAddress: PropTypes.string,
    card: PropTypes.object.isRequired,
    cardHeading: PropTypes.string.isRequired,
    cardSubHeading: PropTypes.string.isRequired,
    goToFindLocalRep: PropTypes.func.isRequired,
    hideFindRepPopup: PropTypes.func.isRequired,
    isLocalRepLoading: PropTypes.bool,
    isLocalRepPopupLoading: PropTypes.bool.isRequired,
    loadLocalRep: PropTypes.func.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    localRepImages: PropTypes.array,
    localRepresentatives: PropTypes.string.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    onFindYourRep: PropTypes.func.isRequired,
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    pictureUrl: PropTypes.string,
    representativeSearch: PropTypes.object,
    selectAction: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    showFindYouRepPopup: PropTypes.bool.isRequired,
    useLocalRepresentative: PropTypes.bool,
    endUserLocation: PropTypes.object
};

export default connect(
    state => {
        let reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.cards[state.widget.activeAction.order - 1]
                      .representativeSearch,
                  state.localRep.localRepData.representative
              )
            : [];
        const actions = state.widget.actions.filter(
            a =>
                a.order === state.widget.activeAction.order &&
                a.order.type === state.widget.activeAction.order.type
        );
        const contactKeys = actions.map(action =>
            action.type === 'email'
                ? 'canBeEmailed'
                : action.type === 'call'
                ? 'phone'
                : 'fullName'
        );
        const contactableReps = reps.filter(rep => contactKeys.some(key => !!rep[key]));
        if (contactableReps.length) reps = contactableReps;
        reps = reps.slice(0, 3);
        const repNames = !!state.localRep.localRepData.representative
            ? joinEnglish(reps.map(rep => `${rep.shortName}${districtInfo(rep)}`))
            : null;

        return {
            address: state.form.google_autocomplete
                ? state.form.google_autocomplete.values.address
                : '',
            addressValidationError: state.widget.addressValidationError,
            actions: actions
                .map(a => ({
                    label:
                        a.customButtonText !== undefined
                            ? a.customButtonText
                            : copyFor('buttons', 'start', a.type),
                    identifier: a.identifier,
                    type: a.type,
                    name: a.name,
                    useLocalRepresentative: !!a.representativeSearch,
                    position: state.widget.cards[
                        state.widget.activeAction.order - 1
                    ].actions.indexOf(a),
                    localRepTwitterMention: !!state.localRep.localRepData.representative
                        ? joinEnglish(
                              reps.map(rep => '@' + (rep.twitterMention || rep.fullName))
                          )
                        : '@Speakable'
                }))
                .slice(0, 3),
            actionIdentifier: state.widget.activeAction.identifier,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            cardHeading: state.widget.cards[state.widget.activeAction.order - 1].heading
                .replace(
                    new RegExp(Placeholders.LocalRepresentative, 'g'),
                    repNames || 'Speakable'
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    repNames || '@Speakable'
                ),
            cardSubHeading: state.widget.cards[
                state.widget.activeAction.order - 1
            ].subHeading
                .replace(
                    new RegExp(Placeholders.LocalRepresentative, 'g'),
                    repNames || 'Speakable'
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    repNames || '@Speakable'
                ),
            isLocalRepLoading: state.localRep.isLocalRepLoading,
            isLocalRepPopupLoading: state.localRep.isLocalRepPopupLoading,
            localRepFound: state.localRep.localRepData.representative !== undefined,
            localRepImages: !!state.localRep.localRepData.representative
                ? reps.map(rep => rep.photoUrl || DefaultRepImageURL)
                : [],
            localRepresentatives: repNames || '',
            pictureUrl: pictureUrl(state),
            representativeSearch: state.widget.maximumRepresentativeSearch,
            showFindYouRepPopup: state.localRep.showFindYouRepPopup,
            useLocalRepresentative: !!state.widget.activeAction.representativeSearch,
            endUserLocation: state.widget.endUserLocation,
            cachedAddress: buildCachedAddress(
                state.form.google_autocomplete
                    ? state.form.google_autocomplete
                    : state.cachedFormData
            )
        };
    },
    {
        goToFindLocalRep,
        hideFindRepPopup,
        loadLocalRep,
        onBackWithinCard,
        onFindYourRep,
        onGoToNextActionInsideCard,
        selectAction,
        setOverlayPartnerVisible
    }
)(TargetedMultiActionDetails);
